import { Injectable } from '@nestjs/common';
import { OidDefinition } from '../interfaces/oid';
import { OidDB } from './oid.service';

@Injectable() 
export class HuaweiOidDB extends OidDB {
    Base(): string {
        return '1.3.6.1.4.1.2011.';  // Huawei company OID
    }
    Frame(): OidDefinition {
        return {
            base: this.Base() + '6.3.3.1.1',
            children: {
                hwFrameIndex: '1.0',
                hwFrameType: '2.0',
                hwFrameDesc: '3.0',
                hwSlots: '4.0',
                hwFrameOperStatus: '5.0',
                hwFrameRowStatus: '7.0',
                hwBackplaneVersion: '8.0',
                hwBackplanePhySerialNum: '9.0',
                hwFrameTypeName: '12.0'
            }
        }
    }
    Slots(): OidDefinition {
        return {
            base: this.Base() + '6.3.3.2.1',
            children: {
                hwSlotIndex: '1.0',
                hwSlotOperStatus: '8.0',
                hwSlotPhySerialNum: '11.0',
                hwSlotTypeName: '21.0'
            }
        }
    }
    SubSlots(): OidDefinition {
        return {
            base: this.Base() + '6.3.3.3.1',
            children: {
                hwSubslotIndex: '1.0',
                hwSubslotPorts: '3.0'
            }
        }
    }
    Ports(): OidDefinition {
        return {
            base: this.Base() + '6.3.3.4.1',
            children: {
                hwPortIndex: '1.0',
                hwPortType: '2.0',
                hwPortDesc: '3.0',
                hwPortOperStatus: '5.0',
                hwPortAdminStatus: '6.0',
                hwPortNetworkRole: '7.0',
                hwPortPrimaryStatus: '9.0',
                hwPortSecondaryStatus: '10.0'
            }
        }
    }
    GponPorts(): OidDefinition {
        return {
            base: this.Base() + '6.128.1.1.2',
            children: {
                hwGponDeviceOltControlAutofindOntEnable: '21.1.4',
                hwGponDeviceOltControlLaserSwitch: '21.1.9',
                hwGponDeviceOltControlStatus: '21.1.10',
                hwGponDeviceOltControlOpticModuleStatus: '21.1.13',
                hwGponDeviceOltControlAvailableBandWidth: '21.1.14',
                hwGponDeviceOltObjectOpticAlarmProfileName: '21.1.15',
                hwGponDeviceOltControlOntNum: '21.1.16',
                hwGponDeviceOltLastUpTime: '21.1.17',
                hwGponDeviceOltLastDownTime: '21.1.18',
                hwGponDeviceOltLastDownCause: '21.1.19',
                hwGponDeviceOltControlTcontNumCombined: '21.1.20',
                hwGponDeviceOltControlTcontNumInCard: '21.1.21',
                hwGponOltOpticsModuleInfoVendorSN: '22.1.13',
                hwGponOltOpticsDdmInfoTemperature: '23.1.1',
                hwGponOltOpticsDdmInfoTxPower:'23.1.4'
            }
        }
    }

    GponLineProfiles(): OidDefinition {
        return {
            base: this.Base() + '6.128.1.1.3.61',
            children: {
                hwGponDeviceLineProfileBindNum: '1.2',
                hwGponDeviceLineProfileUpFEC: '1.3',
                hwGponDeviceLineProfileMappingMode: '1.4',
                hwGponDeviceLineProfileQosMode: '1.5',
                hwGponDeviceLineProfileCommit: '1.6',
                hwGponDeviceLineProfileRowStatus: '1.7',
                hwGponDeviceLineProfileOMCCEncrypt: '1.8',
                hwGponDeviceLineProfileTr069ManagementSwitch: '1.9',
                hwGponDeviceLineProfileCommitResult: '1.11',
                hwGponDeviceLineProfileTr069ManagementIpIndex: '1.12'
            }
        }
    }

    GponServiceProfiles(): OidDefinition {
        return {
            base: this.Base() + '6.128.1.1.3.65',
            children: {
                hwGponDeviceSrvProfileBindNum: '1.2',
                hwGponDeviceSrvProfileCommit: '1.3',
                hwGponDeviceSrvProfileRowStatus: '1.4'
            }
        }
    }

    GponOntAutofound(): OidDefinition {
        return {
            base: this.Base() + '6.128.1.1.2.52.1',
            children: {
                hwGponDeviceOntRegisterSn: '2',
                hwGponDeviceOntRegisterResult: '3',
                hwGponDeviceOntRegisterTime: '4',
                hwGponDeviceOntRegisterConflictedIfindex: '5',
                hwGponDeviceOntRegisterConflictedOntIndex: '6',
                hwGponDeviceOntRegisterOntVendorId: '8',
                hwGponDeviceOntRegisterOntVersion: '9',
                hwGponDeviceOntRegisterOntMainSoftVersion: '10',
                hwGponDeviceOntRegisterOntEquipmentId: '11',
                hwGponDeviceOntRegisterOntLoid: '12'
            }
        }
    }
    GponDeviceOnt(): OidDefinition {
        return {
            base: this.Base() + '6.128.1.1.2.43.1',
            children: {
                hwGponDeviceOntAuthMethod: '2',
                hwGponDeviceOntSn: '3',
                hwGponDeviceOntPassword: '4',
                hwGponDeviceOntTimeOut: '5',
                hwGponDeviceOntManagementMode: '6',
                hwGponDeviceOntLineProfName: '7',
                hwGponDeviceOntServiceProfName: '8',
                hwGponDeviceOntDespt: '9',
                hwGponDeviceOntEntryStatus: '10',
                hwGponDeviceOntProtectSide: '11',
                hwGponDeviceOntPGMemberRole: '12'
            }
        }
    }

    GponOntInfoTable(): OidDefinition {
        return {
            base: this.Base() + '6.145.1.1.1.4.1',
            children: {
                hwXponOntInfoOnlineDuration: '1',
                hwXponOntInfoMemoryOccupation: '2',
                hwXponOntInfoCpuOccupation: '3',
                hwXponOntInfoTemperature: '4',
                hwXponOntInfoProductDescription: '5',
                hwXponDeviceOntControlPrimaryStatus: '6',
                hwXponDeviceOntControlSecondaryStatus: '7',
                hwXponOntLastDistance: '12',
                hwXponOntInfoInteroperabilityStandard: '15'
            }
        }
    }

    SrvFlowTable() : OidDefinition {   // Service Port table
        return {
            base: this.Base() + '5.14.5.2',
            children: {
                hwExtSrvFlowPara1: '1.2',  // shelf ID
                hwExtSrvFlowPara2: '1.3',  // slot ID
                hwExtSrvFlowPara3: '1.4',  // port ID
                hwExtSrvFlowPara4: '1.5',  // ONT id (ParaType: 4) and endpoint (ParaType: 14)
                hwExtSrvFlowPara5: '1.6',  // GEM or Eth port (based on ParaType, see mib)
                hwExtSrvFlowParaType: '1.7', // 4: gpon, 14: xponEndToEnd
                hwExtSrvFlowVlanid: '1.8',
                hwExtSrvFlowReceiveTrafficDescrIndex: '1.9',
                hwExtSrvFlowTransmitTrafficDescrIndex: '1.10',
                hwExtSrvFlowMultiServiceType: '1.11',
                hwExtSrvFlowMultiServiceUserPara: '1.12',
                hwExtSrvFlowAdminStatus: '1.13',
                hwExtSrvFlowOperStatus: '1.14',
                hwExtSrvFlowRowStatus: '1.15',
                hwExtSrvFlowInnerVlanId: '1.16',
                hwExtSrvFlowDescInfo: '1.17',
                hwExtSrvFlowTagTransform: '1.18',
                hwExtSrvFlowSimulationServiceType: '1.19',
                hwExtSrvFlowRemoteDescInfo: '1.20',
                hwExtSrvFlowOutboundTrafficTableName: '1.21',
                hwExtSrvFlowInboundTrafficTableName: '1.22',
                hwExtSrvFlowEntry: '1.42'
            }
        }
    }
    
    HwIpTrafficParamTable() : OidDefinition {
        return {
            base: this.Base() + '5.14.3.8.1',
            children: {
                hwIpTrafficName: '2',
                hwIpTrafficCir: '3',
                hwIpTrafficCbs: '4',
                hwIpTrafficPir: '5',
                hwIpTrafficPbs: '6',
                hwIpTrafficCm: '7',
                hwIpTrafficPriority: '8',
                hwIpTrafficPriorityPolicy: '9',
                hwIpTrafficRowStatus: '10',
                hwIpTrafficInnerPriority: '11',
                hwIpTrafficInnerPriorityMappingIndex: '12',
                hwIpTrafficPriorityMappingIndex: '13',
                hwIpTrafficColorPolicy: '14',
                hwIpTrafficCarThresholdProfileIndex: '15',
                hwIpTrafficFixBandWidth: '16'
            }
        }
    }

    Vlans(): OidDefinition {
        return {
            base: this.Base() + '5.6.1.1.1',
            children: {
                hwVlanIndex: '1',
                hwVlanDescription: '2',
                hwVlanPorts: '3',
                hwVlanType: '4'
            }
        }
    }
    
    hwGponDeviceOntOpticalDdmInfoTable(): OidDefinition {
        return {
            base: this.Base() + '6.128.1.1.2.51.1',
            children: {
                hwGponOntOpticalDdmTemperature: '1',    // The temperature of the optical module, unit C(centigrade).
                hwGponOntOpticalDdmBiasCurrent: '2',    // The Bias Current of the optical module, unit mA.
                hwGponOntOpticalDdmTxPower: '3',        // The transmitting power of the optical module, unit 0.01dBm.
                hwGponOntOpticalDdmRxPower: '4',        // The receiving power of the optical module, unit 0.01dBm.
                hwGponOntOpticalDdmVoltage: '5',        // The power feed voltage of the optical module, unit mV.
                hwGponOntOpticalDdmOltRxOntPower: '6',  // The OLT received ONT power of the optical module, ranging from -99 to 100, unit 0.01dBm.
                hwGponOntOpticalDdmAniCATVRxPower: '7', // Indicates the CATV receiving optical power of the optical module, unit 0.01dBm.
            }
        }
    }

    hwGponDeviceOntEthernetTable(): OidDefinition {
        return {
            base: this.Base() + '6.128.1.1.2.62.1',
            children: {
                hwGponDeviceOntEthernetDuplexMode: '3',
                hwGponDeviceOntEthernetSpeed: '4',
                hwGponDeviceOntEthernetOnlineState: '22'
            }
        }
    }
}
